// @flow

import React from 'react'
import type { Element } from 'react'

import { Field } from 'formik'
import type { FormikContext } from 'formik'

import type { FormData } from '../../types'

import {
  PillButtonSubmit as PillButton,
  InputGroup,
  TextareaField,
} from '../../components'
import { contactContent } from './contact-content'
import type { ContactPageForm } from '../../types/i18n/contact-page-form'

type PureContactFormProps = {
  formik: FormikContext<FormData>,
  content: ContactPageForm,
}

function FormField({ name, required }: { name: string, required?: boolean }) {
  return (
    <Field
      name={name}
      component={InputGroup}
      label={contactContent.form[name].label}
      placeholder={contactContent.form[name].placeholder}
      required={required}
    />
  )
}
FormField.defaultProps = {
  required: false,
}

export function PureContactForm({
  formik,
  content,
}: PureContactFormProps): Element<'form'> {
  const { handleSubmit, isSubmitting, isValid } = formik
  const formSubmissionDisabled = isSubmitting || !isValid

  return (
    <form
      className="max-w-md mt-12"
      name="contact"
      method="post"
      onSubmit={handleSubmit}
      data-netlify="true"
      data-netlify-honeypot="botField"
    >
      <div className="sm:flex sm:items-center mb-5 sm:-mx-2">
        <div id="first-name" className="sm:w-1/2 mb-6 sm:mb-0 sm:px-2">
          <FormField name="firstName" required />
        </div>
        <div id="last-name" className="sm:w-1/2 mb-6 sm:mb-0 sm:px-2">
          <FormField name="lastName" required />
        </div>
      </div>
      <div id="email" className="mb-4">
        <FormField name="email" required />
      </div>
      <div id="phone" className="mb-4">
        <FormField name="phone" />
      </div>
      <div id="botField" className="mb-4 hidden">
        <FormField name="botField" required />
      </div>
      <div id="message" className="mb-4">
        <TextareaField name="message" content={content} form={formik} />
      </div>
      <div className="flex">
        <div className="w-1/3 ml-auto">
          <PillButton
            className="w-full"
            value={content.form.submitButton.label}
            type="submit"
            onClick={handleSubmit}
            disabled={formSubmissionDisabled}
          />
        </div>
      </div>
    </form>
  )
}

export default PureContactForm
